import { useMemo } from "react"
import { isLocaleRTL } from "../domHelpers/isLocaleRTL"

export const useIsRTL = (): boolean => {
  return useMemo(() => isLocaleRTL(navigator.language), [])
}
